function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M72.3788 51.4494V29.6772C72.3788 19.7753 64.3239 11.7204 54.422 11.7204C44.5209 11.7204 36.4652 19.7753 36.4652 29.6772V51.4494H25.2427V29.6772C25.2427 13.5873 38.3321 0.49707 54.422 0.49707C70.5127 0.49707 83.6021 13.5873 83.6021 29.6772V51.4494H72.3788Z",
  fill: "#FEDD60"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.2427 42.3984H36.4652V51.4504H25.2427V42.3984Z",
  fill: "#FECC2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.3789 42.3984H83.6022V51.4504H72.3789V42.3984Z",
  fill: "#FECC2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.7384 48.9775H25.1061C19.8238 48.9775 15.541 53.2595 15.541 58.5418V99.9324C15.541 105.215 19.8229 109.497 25.1061 109.497H83.7384C89.0207 109.497 93.3035 105.215 93.3035 99.9324V58.5418C93.3035 53.2595 89.0207 48.9775 83.7384 48.9775Z",
  fill: "#A78BD6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.3136 99.9324V58.5418C24.3136 53.2595 28.5955 48.9775 33.8779 48.9775H25.1053C19.8229 48.9775 15.541 53.2595 15.541 58.5418V99.9324C15.541 105.215 19.8229 109.497 25.1053 109.497H33.8779C28.5955 109.497 24.3136 105.215 24.3136 99.9324Z",
  fill: "#8363BA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.0072 84.1663C60.0072 81.0818 57.5065 78.582 54.4221 78.582C51.3377 78.582 48.8379 81.0818 48.8379 84.1663C48.8379 86.1613 49.884 87.911 51.4574 88.8989V92.2636C51.4574 93.901 52.7847 95.2282 54.4221 95.2282C56.0604 95.2282 57.3876 93.901 57.3876 92.2636V88.8989C58.961 87.911 60.0072 86.1613 60.0072 84.1663Z",
  fill: "#41476B"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 109,
  height: 109,
  fill: "white",
  transform: "translate(0 0.49707)"
})));

var SvgPadlock = function SvgPadlock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 110,
    viewBox: "0 0 109 110",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPadlock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/padlock.4e0cf7b6.svg";
export { ForwardRef as ReactComponent };